import React, { useEffect, useState } from 'react';
import AppSettingsContext from './AppSettingsContext';
import { eventGridLayoutPADefault, eventGridLayoutFFDefault, eventGridLayoutGEDefault, eventGridLayoutName, eventGridLayoutVersion, GridLayouts } from '../interfaces/IGridSettings';
import { accordionVisible, dataGridColumnVisible, documentGridColumnVisible } from '../interfaces/IFields';

interface Props {
	children: React.ReactNode;
}

export const AppSettingsContextProvider = ({ children }: Props) => {
const [isDarkTheme, setIsDarkTheme] = useState<boolean>(
	() => JSON.parse(localStorage.getItem('isDarkTheme') || "false")
);

const [showToDateExpired, setShowToDateExpired] = useState<boolean>(
	() => JSON.parse(localStorage.getItem('showToDateExpired') || "true")
);

const [eventGridLayout, setEventGridLayout] = useState<GridLayouts>(
	() => JSON.parse(localStorage.getItem(eventGridLayoutName + eventGridLayoutVersion) || JSON.stringify({
		Generell: eventGridLayoutGEDefault,
		Fellesfeil: eventGridLayoutFFDefault,
		Planlagt: eventGridLayoutPADefault
	}))
);

const [accordionState, setAccordionState] = useState<{ [key: string]: boolean }>(
	() => JSON.parse(localStorage.getItem('AccordionVisible') || JSON.stringify(accordionVisible))
);

const [documentGridColumnState, setDocumentGridColumnState] = useState<{ [key: string]: boolean }>(
	() => JSON.parse(localStorage.getItem('DocumentGridColumnVisible') || JSON.stringify(documentGridColumnVisible))
);

const [dataGridColumnState, setDataGridColumnState] = useState<{ [key: string]: boolean }>(
	() => JSON.parse(localStorage.getItem('DataGridColumnVisible') || JSON.stringify(dataGridColumnVisible))
);

useEffect(() => {
	localStorage.setItem(eventGridLayoutName + eventGridLayoutVersion, JSON.stringify(eventGridLayout));
}, [eventGridLayout]);

useEffect(() => {
	localStorage.setItem('isDarkTheme', JSON.stringify(isDarkTheme));
}, [isDarkTheme]);

useEffect(() => {
	localStorage.setItem('showToDateExpired', JSON.stringify(showToDateExpired));
}, [showToDateExpired]);

useEffect(() => {
	localStorage.setItem('AccordionVisible', JSON.stringify(accordionState));
}, [accordionState]);

useEffect(() => {
	localStorage.setItem('DocumentGridColumnVisible', JSON.stringify(documentGridColumnState));
}, [documentGridColumnState]);

useEffect(() => {
	localStorage.setItem('DataGridColumnVisible', JSON.stringify(dataGridColumnState));
}, [dataGridColumnState]);

const contextValue = {
	isDarkTheme,
	setIsDarkTheme,
	accordionState,
	setAccordionState,
	documentGridColumnState,
	setDocumentGridColumnState,
	dataGridColumnState,
	setDataGridColumnState,
	eventGridLayout,
	setEventGridLayout,
	showToDateExpired,
	setShowToDateExpired
};

return (
	<AppSettingsContext.Provider value={contextValue}>
		{children}
	</AppSettingsContext.Provider>
	);
};

export const useAppContext = () => {
	return React.useContext(AppSettingsContext);
};